import React, { Component } from "react";
import {
    brand1,
    brand2,
    brand3,
    brand4,
    // brand5,
    brand6,
    // brand7
} from 'assets/images';

class BrandTwo extends Component{
    render(){
        return(
            <React.Fragment>
                <ul className="brand-style-2">
                    <li>
                        <img src={brand1} alt="Plot 256"/>
                    </li>
                    <li>
                        <img src={brand2} alt="Jumbo Flights"/>
                    </li>
                    <li>
                        <img src={brand3} alt="Net Cyber Techs"/>
                    </li>
                    <li>
                        <img src={brand4} alt="Velocity Crypto"/>
                    </li>
                    {/*<li>*/}
                    {/*    <img src={brand5} alt="Navi E-sports"/>*/}
                    {/*</li>*/}
                    <li>
                        <img src={brand6} alt="Pamooja"/>
                    </li>
                </ul>
            </React.Fragment>
        )
    }
}
export default BrandTwo;
